var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.24477,
    cy: 8.0976,
    r: 8,
    transform: "rotate(1.33004 8.24477 8.0976)",
    fill: "#FFDE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse7);
export default __webpack_public_path__ + "static/media/Ellipse 7.040686e0908c7ace60b29c7c2141b5ed.svg";
export { ForwardRef as ReactComponent };